import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import {Observable, of} from 'rxjs';

import {CoreTicketingService} from "@appServices/core-ticketing/core-ticketing.service";
import {catchError, tap} from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class TicketTypeService extends CoreTicketingService {

  constructor(
    private http: HttpClient,
  ) {
    super(http, 'tickettype');
    this.headers = this.headers.append('skip-cache', 'true');
  }

  getTicketTypes(useTenant: boolean): Observable<any> {

    let tenantId = localStorage.getItem('tenant');
    let params = {};
    if (useTenant) {
      params = {
        tenantId: tenantId
      }
    }

    const url = `${this.base_url}/types`;
    return this.http.get<any>(url, {params: params, headers: this.headers}).pipe(
      tap(any => this.log(`fetched SmileIdentity`)),
      catchError(this.handleError<any>(`getSmileIdentity`, []))
    );
  }

  createTicketType(body: any , useTenant: boolean): Observable<any> {

    let tenantId = localStorage.getItem('tenant');
    let params = {};
    if (useTenant) {
      params = {
        tenantId: tenantId
      }
    }

    const url = `${this.base_url}/createTicketType`;
    return this.http.post<any>(url, body,{params: params, headers: this.headers}).pipe(
      tap(any => this.log(`fetched SmileIdentity`)),
      catchError(this.handleError<any>(`getSmileIdentity`, []))
    );
  }

  getTicketType(id:number): Observable<any> {
    const url = `${this.base_url}/getTicketType/${id}`;
    return this.http.get<any>(url,{headers: this.headers}).pipe(
      tap(any => this.log(`fetched SmileIdentity`)),
      catchError(this.handleError<any>(`getSmileIdentity`, []))
    );
  }

  updateTicketType(id:number, body: any): Observable<any> {


    const url = `${this.base_url}/updateTicketType/${id}`;
    return this.http.post<any>(url, body,{headers: this.headers}).pipe(
      tap(any => this.log(`fetched SmileIdentity`)),
      catchError(this.handleError<any>(`getSmileIdentity`, []))
    );
  }

  validateNewWorkflow(id:number, workflowId?:number): Observable<any> {
    let params = {};
    if (workflowId != null) {
      params = {
        workflowId: workflowId
      }
    }
    const url = `${this.base_url}/validateNewWorkflow/${id}`;
    return this.http.get<any>(url,{params:params, headers: this.headers}).pipe(
      tap(any => this.log(`fetched SmileIdentity`)),
      catchError(this.handleError<any>(`getSmileIdentity`, []))
    );
  }

}
